import SendbirdChat from '@sendbird/chat';
import { GroupChannelModule } from '@sendbird/chat/groupChannel';

const sb = SendbirdChat.init({
  appId: process.env.REACT_APP_SENDBIRD_ID,
  modules: [new GroupChannelModule()],
});

export default sb;
